<template>
    <div>
        <div class="container p-3 pt-5 my-4 border in-border-header">
            <div class="section-header">
                {{ $t('pos.admin_description') }}
            </div>
            <kt-row v-if="description">
                <kt-col lg="12" md="12" xs="12">
                    <kt-form-group>
                        <kt-form-textarea v-model="description" dir="rtl" name="description"
                                          id="description" disabled
                        ></kt-form-textarea>


                    </kt-form-group>
                </kt-col>
            </kt-row>
        </div>
    </div>
</template>

<script>

export default {
    name: "change-status",
    props: {
        description:{
            required :true
        }
    },
    mounted() {
        // var textarea = document.getElementById("description");
        // textarea.value = this.description.join("\n");
    }
}
</script>

<style scoped>

</style>